import { Component, Input, OnInit } from '@angular/core';
import { LandLineListInterface } from '../../../../landlines/models/land-line-list.interface';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { Store } from '@ngrx/store';
import { CustomerStorageService } from '../../../../account/services/customer-storage.service';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { LandLinesService } from '../../../../landlines/services/land-lines.service';
import { AppointmentInterface } from '../../../../landlines/models/appointment.interface';
import moment from 'moment';
import { environment } from '../../../../../../environments/environment';
import { ShiftAppointmentInterface } from '../../../../landlines/models/shift-appointment.interface';
import { UpdateLandlineMission } from '../../../store/actions/landline-mission.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { AlertMessageInterface } from '../../../models/alert-message.interface';
import { GetAlertMessage } from '../../../store/actions/alert-message.actions';

@Component({
  selector: 'app-modify-appointment',
  templateUrl: './modify-appointment.component.html',
  styleUrls: ['./modify-appointment.component.css'],
  standalone: false
})
export class ModifyAppointmentComponent implements OnInit {

  @Input()
  landLine: LandLineListInterface|null;

  @Input()
  procedureCode: string;

  @Input()
  lastMessage: any;

  environment = environment;
  moment = moment;
  customer: CustomerInterface;
  appointmentsList: Array<AppointmentInterface> = [];
  selectedAppointment: {
    reference: string|null,
    date: string|null,
    timeSlot: string|null,
    startHour: number|null,
    endHour: number|null
  } = {
    reference: null,
    date: null,
    timeSlot: null,
    startHour: null,
    endHour: null,
  };
  appointments: Array<{ reference: string, date: string, timeSlot: string, startHour: number, endHour: number }> = [];
  inProgressAppointment: {
    appointmentDate: string;
    appointmentEndHour: number;
    appointmentStartHour: number;
    interventionType?: string;
    idAboOp: string;
    ref_intervention: string;
    site_address: {
      address: {
        city: string;
        citycode: string;
        name: string;
      },
      mediaPostAddress : {
        city: string;
        cityToDisplay: string;
        coordX: number;
        coordY: number;
        idRa: string;
        streetName: string;
        streetNumber: string;
        streetNumberComplement: string;
        xyCoding: string;
        zipCode: string;
      } | null
      buildingId: string;
    }
  }|null;
  constructor(
      private store: Store<any>,
      private landLinesService: LandLinesService,
      private customerStorage: CustomerStorageService,
  ) {
  }

  ngOnInit() {
    this.inProgressAppointment = this.lastMessage.data;
    this.customer = this.customerStorage.getCustomer();
    this.landLinesService.getList(this.inProgressAppointment.site_address.buildingId, '1').subscribe(
        list => {
          if (list && list.available_slots && list.available_slots.length > 0) {
            this.appointmentsList = list.available_slots;
            if (this.selectedAppointment && this.selectedAppointment.reference) {
              this.loadSchedules();
            }
          }
        }
    );
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  appointmentDateFilter = (forDay: Date) => {
    const currentDate = moment(forDay).format('YYYY-MM-DD');
    return this.appointmentsList.some(
        (date) => date.date === currentDate
    );
  }

  setAppointmentDate($event: any) {
    this.selectedAppointment.date = moment($event).format('YYYY-MM-DD');
    this.selectedAppointment.timeSlot = null;
    this.selectedAppointment.startHour = null;
    this.selectedAppointment.endHour = null;
    this.selectedAppointment.reference = null;
    this.loadSchedules();
  }

  setSelectedAppointment(appointment: { reference: string, timeSlot: string, date: string, endHour: number, startHour: number }) {
    this.selectedAppointment = appointment;
  }

  confirmation() {
    if (this.selectedAppointment.date && this.selectedAppointment.timeSlot && this.selectedAppointment.reference) {
      const shiftAppointment: ShiftAppointmentInterface = {
        id_abo_op: this.inProgressAppointment.idAboOp,
        ref_intervention: this.inProgressAppointment.ref_intervention,
        ref_time_slot: this.selectedAppointment.reference,
        rdv_date: this.selectedAppointment.date,
        rdv_start_hour: this.selectedAppointment.startHour,
        id_block: this.inProgressAppointment.site_address.buildingId,
        rdv_end_hour: this.selectedAppointment.endHour,
        landline: this.landLine.phoneNumber,
        comment: 'Déplacer le rdv'
      };
      this.landLinesService.shiftAppointment(shiftAppointment).subscribe(responseShift => {
        this.inProgressAppointment.appointmentDate = this.selectedAppointment.date;
        this.inProgressAppointment.appointmentStartHour = this.selectedAppointment.startHour;
        this.inProgressAppointment.appointmentEndHour = this.selectedAppointment.endHour;
        this.inProgressAppointment.ref_intervention = responseShift.ref_intervention;
        // send new ref intervention
        this.store.dispatch(
          new UpdateLandlineMission(
            {
              step: 1,
              landline: this.landLine.phoneNumber,
              data: this.inProgressAppointment
            },
            this.procedureCode
          )
        );
      }, error => {
        const alertMessage = {
          message: ConstsHelper.ERROR_OCCURRED_MESSAGE,
          code: 400
        } as AlertMessageInterface;
        this.store.dispatch(new GetAlertMessage(alertMessage));
      });
    }
  }

  private loadSchedules() {
    this.appointments = [];
    for (const appointment of this.appointmentsList) {
      if (this.selectedAppointment.date === appointment.date) {
        this.selectedAppointment.reference = appointment.ref_time_slot;
        const hour = this.formatAppointmentHour(appointment.start_hour) + ' - ' + this.formatAppointmentHour(appointment.end_hour);
        this.appointments.push(
            {
              reference: appointment.ref_time_slot,
              timeSlot: hour,
              date: appointment.date,
              endHour: appointment.end_hour,
              startHour: appointment.start_hour
            }
        );
      }
    }
  }

  formatAppointmentHour(hour: number) {
    let result = (hour / 100).toString();
    if ((hour / 100) < 10) {
      result = '0' + result;
    }
    return result + ':00';
  }
}
